import React, { useEffect, useState } from "react";
import "./webhookDetails.css";
import { Box, Modal, Typography } from "@mui/material";
import { convertIsoToGivenTimeZone } from "../../../utils/utils";
import ReactJson from "react-json-pretty";
import CustomChips from "../../../../reusableComponents/CustomChips";
import HoverToDisplayFullTitle from "../../../../reusableComponents/HoverToDisplayFullTitle";
import { useAuth } from "../../../../context/API_Client";
import { customToast } from "../../../../reusableComponents/customToaster/customToast";

const modalStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const contentStyle = {
  backgroundColor: "#fff",
  padding: "20px 32px",
  borderRadius: "16px",
  height: "730px",
  width: "1080px",
};

function ResponseModal({ open, onClose, createdWebhook }) {
  const { merchantSettings } = useAuth();
  const [timeZone, setTimeZone] = useState("");

  useEffect(() => {
    merchantSettings(
      function (data) {
        setTimeZone(data?.timeZone);
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
      }
    );
  }, []);
  return (
    <div>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={modalStyle}
      >
        <Box sx={contentStyle}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              width: "100%",
            }}
          >
            <div className="response-header">
              <Typography className="subHeaderSemiBold">
                Test Results:
              </Typography>

              <img
                src="/assets/ic_twotone-close.svg"
                alt="cross"
                onClick={onClose}
                style={{ cursor: "pointer" }}
              />
            </div>

            <div style={{ display: "flex", gap: "76px" }}>
              <div className="response-subheader">
                <Typography className="bodyB2Medium font-gray">
                  Date & Time:
                </Typography>
                <Typography className="subHeaderMedium">
                  {timeZone && convertIsoToGivenTimeZone(
                    createdWebhook?.notificationPayload?.timestamp,
                    timeZone
                  )}
                </Typography>
              </div>

              <div className="response-subheader">
                <Typography className="bodyB2Medium font-gray">
                  Status:
                </Typography>

                <CustomChips
                  type={0}
                  text={createdWebhook?.notificationResponseStatusCode}
                />
              </div>
            </div>

            <div className="response-subheader">
              <Typography className="bodyB2Medium font-gray">
                Status Notify URL:
              </Typography>
              <Typography className="response-reponse-error">
                {createdWebhook?.statusNotifyUrl}
              </Typography>
            </div>

            <div className="response-subheader">
              <Typography className="bodyB2Medium font-gray">
                Request Payload:
              </Typography>
              <div
                style={{
                  backgroundColor: "var(--neutral-11, #1F1F1F)",
                  borderRadius: "20px",
                  width: "100%",
                }}
              >
                <ReactJson
                  data={JSON.stringify(createdWebhook?.notificationPayload)}
                  style={{ height: "380px", overflowY: "auto" }}
                />
              </div>
            </div>

            <div className="response-subheader">
              <Typography className="bodyB2Medium font-gray">
                Response Error:
              </Typography>
              <Typography
                className="response-reponse-error"
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "100%",
                }}
              >
                {createdWebhook?.notificationResponse ? (
                  <HoverToDisplayFullTitle
                    title={createdWebhook?.notificationResponse}
                    len={120}
                  />
                ) : (
                  "No Response"
                )}
              </Typography>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default ResponseModal;
